import { ModelBase, observable } from "@shoothill/core";
import { action, computed } from "mobx";
import moment from "moment";
export class OtherProgrammeNotesModel extends ModelBase<OtherProgrammeNotesModel> {
    public static readonly DEFAULT_ID = null;
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_OTHER_PROGRAMME_NOTE = "";
    public static readonly DEFAULT_DAILY_PROGRAMME_PROGRESS_PHOTOS = [];
    public static readonly DEFAULT_CREATED_BY_USER_ID = "";
    public static readonly DEFAULT_CREATED_DATE = new Date();
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_LAST_UPDATED_BY_USER_ID = "";
    public static readonly DEFAULT_LAST_UPDATED_DATE = "";
    public static readonly DEFAULT_ROW_VERSION = "";

    @observable
    public id: string | null = OtherProgrammeNotesModel.DEFAULT_ID;

    @observable
    public projectId: string | null = OtherProgrammeNotesModel.DEFAULT_PROJECT_ID;

    @observable
    public otherProgrammeNote: string | null = OtherProgrammeNotesModel.DEFAULT_OTHER_PROGRAMME_NOTE;

    @observable
    public otherProgrammePhotos: OtherProgrammeNotesFile[] = OtherProgrammeNotesModel.DEFAULT_DAILY_PROGRAMME_PROGRESS_PHOTOS;

    @observable
    public createdByUserId: string | null = OtherProgrammeNotesModel.DEFAULT_CREATED_BY_USER_ID;

    @observable
    public createdDate: any = OtherProgrammeNotesModel.DEFAULT_CREATED_DATE;

    @observable
    public isDeleted: boolean = OtherProgrammeNotesModel.DEFAULT_IS_DELETED;

    @observable
    public lastUpdatedByUserId: string | null = OtherProgrammeNotesModel.DEFAULT_LAST_UPDATED_BY_USER_ID;

    @observable
    public lastUpdatedDate: string | null = OtherProgrammeNotesModel.DEFAULT_LAST_UPDATED_DATE;

    @observable
    public rowVersion: string | null = OtherProgrammeNotesModel.DEFAULT_ROW_VERSION;

    @computed
    public get hasId(): boolean {
        return this.id !== null && this.id !== undefined && this.id !== "";
    }

    @computed
    public get formattedLastUpdatedDate(): string {
        return moment(this.lastUpdatedDate).format("DD/MM/YYYY @ HH:mm");
    }

    @action
    public fromDto(dto: OtherProgrammeNotesDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    public fromOtherProgrammePhotosPhotosDTO(dto: OtherProgrammeNotesFile[]): void {
        let processedPhotos: OtherProgrammeNotesFile[] = [];
        for (const photo of dto) {
            processedPhotos.push(photo);
        }
        this.otherProgrammePhotos = processedPhotos;
    }

    @action
    public toDto() {
        const OtherProgrammeNotesModel: OtherProgrammeNotesDTO = {
            id: this.id,
            projectId: this.projectId,
            otherProgrammeNote: this.otherProgrammeNote,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            rowVersion: this.rowVersion,
        };

        return OtherProgrammeNotesModel;
    }

    @action
    public reset = () => {
        this.id = OtherProgrammeNotesModel.DEFAULT_ID;
        this.projectId = OtherProgrammeNotesModel.DEFAULT_PROJECT_ID;
        this.otherProgrammeNote = OtherProgrammeNotesModel.DEFAULT_OTHER_PROGRAMME_NOTE;
        this.otherProgrammePhotos = OtherProgrammeNotesModel.DEFAULT_DAILY_PROGRAMME_PROGRESS_PHOTOS;
    };

    // #Start Custome Validation

    @computed
    public get validateOtherProgrammeNote(): string {
        return this.otherProgrammeNote === OtherProgrammeNotesModel.DEFAULT_OTHER_PROGRAMME_NOTE ? "Please enter a note" : "";
    }

    // #End Custome Validation
}

export interface OtherProgrammeNotesDTO {
    id: string | null;
    projectId: string | null;
    otherProgrammeNote: string | null;
    createdByUserId: string | null;
    createdDate: string | null;
    isDeleted: boolean;
    lastUpdatedByUserId: string | null;
    lastUpdatedDate: string | null;
    rowVersion: string | null;
}

export interface OtherProgrammeNotesFile {
    id: string | null;
    otherProgrammeNotesId: string | null;
    fileName: string;
    photoURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
    createdDate: string | null;
}

export interface UpsertOtherProgrammeNotesRequestDTO {
    otherProgrammeNotes: OtherProgrammeNotesDTO;
    otherProgrammeNotesPhotos: OtherProgrammeNotesFile[];
}

export interface UpsertOtherProgrammeNotesResponseDTO {
    otherProgrammeNotes: OtherProgrammeNotesDTO;
    otherProgrammeNotesPhotos: OtherProgrammeNotesFile[];
}

export interface OtherProgrammeNotesByIdResponseDTO {
    otherProgrammeNotes: OtherProgrammeNotesDTO;
    otherProgrammeNotesPhotos: OtherProgrammeNotesFile[];
}

export interface OtherProgrammeNoteResponseDTO {
    otherProgrammeNotes: OtherProgrammeNotesDTO;
    otherProgrammeNotesPhotos: OtherProgrammeNotesFile[];
}

export interface FormRequestDTO {
    date: string | null;
    projectId: string | null;
    formId: string | null;
}
